import { RequiredAddressFieldKeys } from '@/constants';

export const getRequiredAddressFields = (countryCode: string) => [
  ...Object.values(RequiredAddressFieldKeys),
  ...(['GBR', 'IRL', 'USA', 'US'].includes(countryCode) ? ['countyCode'] : []),
];
